module.exports = __webpack_public_path__ + "img/box-packaging-0@1x.4a03c37a.png";